import { useSelector } from 'react-redux';
import { PerformancePeriodDTO } from '../types';
import { periodSelector } from '../state/selectors';

interface Period {
  value?: PerformancePeriodDTO;
  label: string;
  dates: string[];
}

export const usePeriod = (): Period => {
  return useSelector(periodSelector);
};
